import React, { useState } from "react";
import { Lock, Loader2 } from "lucide-react";

// Shown when the online copy of the data is encrypted and this device doesn't have the key yet.
export default function UnlockSyncModal({ onUnlock, onLater, onForgot }) {
  const [pass, setPass] = useState("");
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function submit() {
    if (!pass || busy) return;
    setBusy(true); setErr("");
    try { await onUnlock(pass, remember); }
    catch (e) { setErr(e.message || "Couldn't unlock."); setBusy(false); }
  }

  return (
    <div className="overlay-backdrop fixed inset-0 z-50 flex items-end lg:items-center justify-center" role="dialog" aria-modal="true" aria-label="Unlock your synced data">
      <div className="bg-card2 w-full max-w-md rounded-t-3xl lg:rounded-3xl p-6">
        <Lock size={20} className="text-brass mb-2" />
        <h3 className="v-display text-lg font-semibold">Unlock your synced data</h3>
        <p className="text-xs text-ivory-dim mt-1 mb-4 leading-relaxed">Your online copy is end-to-end encrypted. Enter your encryption passphrase to read it on this device. It isn't your account password, and we can't reset it.</p>
        <input value={pass} onChange={(e) => setPass(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} type="password" autoFocus autoComplete="off" placeholder="Encryption passphrase" className="w-full rounded-lg px-3 py-2.5 text-sm" />
        <label className="flex items-center gap-2 text-xs text-ivory-dim mt-3"><input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} /> Remember on this device</label>
        {err && <div className="text-xs mt-3" style={{ color: "var(--rust)" }}>{err}</div>}
        <button onClick={submit} disabled={!pass || busy} className="w-full mt-4 flex items-center justify-center gap-2 bg-gold-grad text-ink font-semibold rounded-full py-2.5 text-sm disabled:opacity-50">{busy ? <><Loader2 size={15} className="animate-spin" /> Unlocking…</> : "Unlock"}</button>
        <button onClick={onForgot} className="w-full mt-3 py-1.5 text-xs text-brass font-medium underline">Forgot your passphrase?</button>
        <button onClick={onLater} className="w-full mt-1 py-2 text-xs text-ivory-dim">Not now. Keep working on this device only.</button>
      </div>
    </div>
  );
}
